// extracted by mini-css-extract-plugin
module.exports = {"menu":"SGSSelect_menu__sgVbZ","menuItem":"SGSSelect_menuItem__35hrp","menuItem__selected":"SGSSelect_menuItem__selected__2m3uU"};